import { render, staticRenderFns } from "./orderListTC.vue?vue&type=template&id=687fd47e&scoped=true&"
import script from "./orderListTC.vue?vue&type=script&lang=js&"
export * from "./orderListTC.vue?vue&type=script&lang=js&"
import style0 from "./orderListTC.vue?vue&type=style&index=0&id=687fd47e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687fd47e",
  null
  
)

export default component.exports